module.exports = {
  PLEASE_SELECT: '请选择',
  PLEASE_INPUT: '请输入',
  NO_MATCH: '无匹配项目',
  CAL_MONDAY: '一',
  CAL_TUESDAY: '二',
  CAL_WENSDAY: '三',
  CAL_THURSDAY: '四',
  CAL_FRIDAY: '五',
  CAL_SATURDAY: '六',
  CAL_SUNDAY: '日',
  CONFIRM: '确定',
  ALL: '全部',
  UPLOAD: '上传',
  DROPDOWN_LIST: '下拉菜单',
  MULTILEVEL_MENU: '多级菜单',
  GOTO: '跳至',
  PAGE_NEXT: '下一页',
  PAGE_PREV: '上一页',
  CANCEL: '取消',
  NOTICE: '提示',
  ITEM_PAGE: '条/页',
  TOTAL: '共',
  ITEMS: '条',
  PAGE: '页',
  FORMAT_ERROR: '格式错误',
  VALUE_ERROR: '值错误',
  LENGTH_ERROR: '长度错误',
  LOADING: '加载中',
  NO_DATA: '无数据',
  FILE_TYPE_ERROR: '格式错误',
  FILE_TOO_LARGE: '文件过大',
  RETRY: '重试',
  UPLOAD_FILE: '上传文件',
  DOWNLOAD_FILE: '下载',
  UPLOAD_FAIL: '上传失败',
  UNKNOWN: '未知',
  REMOVE_CONFIRM: '确认删除',
  LIMIT_ERROR: 'limit 应该为数字',
  IMAGE_WIDTH_ERROR: '宽度错误',
  IMAGE_HEIGHT_ERROR: '高度错误',
  IMAGE_SCALE_ERROR: '比例错误',
  PLEASE_UPLOAD_ATLEAST: '请至少上传',
  UNIT: '个',
  FILE: '文件',
  SEARCH: '查询',
  RESET: '重置',
  FOLD: '收起',
  UNFOLD: '展开',
  JAN: '1月',
  FEB: '2月',
  MAR: '3月',
  APR: '4月',
  MAY: '5月',
  JUN: '6月',
  JUL: '7月',
  AUG: '8月',
  SEP: '9月',
  OCT: '10月',
  NOV: '11月',
  DEC: '12月',
};



// WEBPACK FOOTER //
// ../src/js/language/zh-CN.js